var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-carousel',{attrs:{"interval":5000,"arrow":"always","height":"500px"}},_vm._l((_vm.swiperList),function(item,i){return _c('el-carousel-item',{key:i},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":item.img,"alt":"","fit":"cover"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }